import React from 'react';
import { LayoutPageGrid } from '../../../../ui/LayoutGrid';
import { CreateSeasonForm } from './CreateSeasonForm';

export const CreateSeasonPage = () => {
  return (
    <LayoutPageGrid title="Создание сезона">
      <CreateSeasonForm />
    </LayoutPageGrid>
  );
};
